// Phone-number search, copied from apps/voip/src/utils/phoneNormalise.js and
// apps/voip/src/utils/phone.js (normalisePhone) on origin/master, 2026-10-26,
// so a typed number lands on the exact string the phone stores in _phones.
// Only the search half is copied. Keep in step with the phone's copy.

export function normalisePhone(input) {
  const raw = input == null ? '' : String(input);
  let cleaned = raw.trim().replace(/[\s\-().]+/g, '');
  cleaned = cleaned.replace(/(?:ext|x|#)\d+$/i, '');
  // A letter AFTER the digits ends the number. GV fields carry
  // annotations like "main press 5", "(CTPS)" and "sitenumber", and
  // reps paste them straight into the dialler; deleting the letters
  // used to glue the menu digit onto the number ("01277 637800 main
  // press 5" dialled +4412776378005). Cut at the first digit→letter
  // boundary instead. Letters BEFORE any digit ("DD01277...") are left
  // for the digit-only collapse below, as ever.
  cleaned = cleaned.replace(/(\d)[a-z].*$/is, '$1');
  // Collapse doubled-plus (++44...) before the leading-zero rule
  // catches the '+' and turns it into +44+...
  cleaned = cleaned.replace(/^\++/, '+');
  if (cleaned.startsWith('+0')) cleaned = '+' + cleaned.slice(2);
  // International dialling prefix 00 → '+'. Must run before the UK
  // leading-zero rule, which otherwise turns 00353... into +44353...
  // (a live mis-dial: a rep dialling Ireland as 0035361513171 was
  // routed to a broken UK number instead).
  if (cleaned.startsWith('00')) cleaned = '+' + cleaned.slice(2);
  if (cleaned.startsWith('0')) cleaned = '+44' + cleaned.slice(1);
  else if (!cleaned.startsWith('+')) cleaned = '+' + cleaned;
  cleaned = '+' + cleaned.replace(/[^\d]/g, '');
  // Strip stray 0 after +44 (the "+44 0207..." misroute). UK
  // subscriber numbers never start with 0; trunk-prefix 0 is dropped
  // when the +44 country code is present.
  cleaned = cleaned.replace(/^\+440(?=\d)/, '+44');
  // Same trunk-zero rescue for Ireland: contacts stored as
  // "+353 087..." keep the Irish trunk 0 and the carrier rejects the
  // structurally-invalid number. Irish area codes never start with 0,
  // so the rewrite is safe.
  cleaned = cleaned.replace(/^\+3530(?=\d)/, '+353');
  // Rescue UK mobiles that lost the "44". A contact stored as bare
  // "7761326742" (no leading 0, no country code) used to be turned
  // into "+7761326742" by the branches above; Twilio then bills it as
  // a (structurally-invalid) Russian/Kazakh landline at ~£0.50/min.
  // Russia + Kazakhstan in E.164 always have 11 digits total after
  // the +; 10 digits starting with 7 only matches a UK mobile that
  // got mis-prefixed, so this rewrite is safe.
  if (/^\+7\d{9}$/.test(cleaned)) cleaned = '+44' + cleaned.slice(1);
  const valid = /^\+\d{8,15}$/.test(cleaned);
  return { e164: cleaned, valid, raw };
}

export function canonicalPhone(raw) {
  const { e164, valid } = normalisePhone(raw);
  return valid ? e164 : '';
}

export function looksLikePhoneSearch(term) {
  const s = (term || '').trim();
  if (!s) return false;
  if (!/^[+\d\s-]+$/.test(s)) return false;
  return (s.match(/\d/g) || []).length >= 3;
}

export function phoneSearchTerm(term) {
  if (!looksLikePhoneSearch(term)) return '';
  const e164 = canonicalPhone(term);
  return /^\+\d{9,15}$/.test(e164) ? e164 : '';
}
